import React from 'react';

const ConfigItem = ({ label, value, scrollable = false }) => {
    if (value === null || value === undefined || value === '') return null;

    const displayValue = typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;

    return (
        <div style={{
            display: 'flex',
            borderBottom: '1px solid #e0e0e0',
            padding: '12px 0'
        }}>
            <div style={{
                fontWeight: 500,
                color: '#666',
                width: '200px',
                flexShrink: 0
            }}>
                {label}
            </div>
            <div style={{
                color: '#333',
                wordBreak: 'break-word',
                flex: 1,
                ...(scrollable && {
                    maxHeight: '150px',
                    overflowY: 'auto',
                    padding: '8px',
                    backgroundColor: '#fff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px'
                })
            }}>
                {displayValue}
            </div>
        </div>
    );
};

export default ConfigItem;